import React from "react";
import { Link } from "react-router-dom";
import "./AppearanceButton.css";

const VARIANTS = {
  primary: "ae-btn--primary",
  secondary: "ae-btn--secondary",
  accent: "ae-btn--accent",
  outline: "ae-btn--outline",
  ghost: "ae-btn--ghost",
  text: "ae-btn--text",
  destructive: "ae-btn--destructive",
  // Entity action aliases → semantic roles
  donate: "ae-btn--primary ae-btn--entity-donate",
  continue: "ae-btn--primary ae-btn--entity-donate",
  follow: "ae-btn--secondary ae-btn--entity-follow",
  following: "ae-btn--secondary ae-btn--entity-following",
  website: "ae-btn--accent ae-btn--entity-website",
  share: "ae-btn--ghost ae-btn--entity-share",
  readmore: "ae-btn--text ae-btn--entity-text",
  readless: "ae-btn--text ae-btn--entity-text",
};

/**
 * Appearance Engine semantic button.
 * Prefer this over hard-coded Bootstrap btn-danger colors.
 */
function AppearanceButton({
  variant = "primary",
  size,
  block = false,
  to,
  href,
  type = "button",
  className = "",
  disabled = false,
  children,
  ...rest
}) {
  const classes = [
    "ae-btn",
    VARIANTS[variant] || VARIANTS.primary,
    size === "sm" ? "ae-btn--sm" : "",
    size === "lg" ? "ae-btn--lg" : "",
    block ? "ae-btn--block" : "",
    disabled ? "is-disabled" : "",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  if (to) {
    return (
      <Link to={to} className={classes} aria-disabled={disabled || undefined} {...rest}>
        {children}
      </Link>
    );
  }

  if (href) {
    return (
      <a
        href={href}
        className={classes}
        aria-disabled={disabled || undefined}
        {...rest}
      >
        {children}
      </a>
    );
  }

  return (
    <button type={type} className={classes} disabled={disabled} {...rest}>
      {children}
    </button>
  );
}

export default AppearanceButton;
